// extracted by css-extract-rspack-plugin
export default {"closeIcon":"vwM7B"};